import React, { useState, useEffect, useContext } from 'react'
import { QuestionContext } from '../../../../Context'
import type { Question } from '../../../../Api'
import { isQuestionActive } from '../../../../Utils'
import { SummaryRow } from './SummaryRow'
import { GeneralSnackbar } from '../../../../Components/Snackbar/generalSnackbar'
import { SnackbarData } from '../../../../Api'

export const Summary: React.FC = () => {
  const { questions } = useContext(QuestionContext)!
  const [questionList, setQuestionList] =
    useState<Question[]>(questions)
  const [weekIsOpen, setWeekIsOpen] = useState<boolean>(false)
  const [showSnackbar, setShowSnackbar] = useState<boolean>(false)
  const [snackbarData, setSnackbarData] = useState<SnackbarData | null>(
    null
  )

  useEffect(() => {
    if (questionList.length < 1) {
      return
    }
    determineSummaryStatus(questionList)
  }, [])

  useEffect(() => {
    if (questions.length < 1) {
      return
    }
    setQuestionList(questions)
    determineSummaryStatus(questions)
  }, [questions])

  const determineSummaryStatus = (qs: Question[]) => {
    let firstQ = qs[0]
    if (isQuestionActive(firstQ.closeTime)) {
      setWeekIsOpen(true)
    }
  }

  return (
    <>
      {questionList.length > 0 &&
        questionList.map((q, idx) => (
          <SummaryRow key={q.id} question={q} index={idx} />
        ))}
      {showSnackbar && snackbarData?.text && (
        <GeneralSnackbar
          text={snackbarData.text || ''}
          color={snackbarData?.color || 'blue'}
          show={showSnackbar}
        />
      )}
    </>
  )
}
